<template>
  <div class="form-group" :class="{ invalid: veeErrors.length > 0 }">
    <label
      v-if="label || legend || description"
      class="form-label"
      :class="{ invalid: veeErrors.length > 0 }"
      >{{ label }}
      <small
        class="form-legend"
        :class="{ invalid: veeErrors.length > 0 }"
        v-if="legend"
        >{{ legend }}</small
      >
      <p
        class="form-description"
        :class="{ invalid: veeErrors.length > 0 }"
        v-if="description"
      >
        {{ description }}
      </p>
    </label>
    <slot></slot>

    <ul class="form-group-errors" v-if="veeErrors.length">
      <li v-for="error of veeErrors" :key="error">
        {{ error }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    for: {
      type: String,
      default: '',
    },

    label: {
      type: String,
      default: '',
    },

    legend: {
      type: String,
      default: '',
    },

    description: {
      type: String,
      default: '',
    },

    veeErrors: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      fieldVal: null,
    }
  },
}
</script>

<style lang="scss" scoped></style>
